export const getRoleLabel = (role) => {
  if (!role) return "";
  if (role.role === "Clinical_Practitioner" && role.clinical_role_name) {
    return role.clinical_role_name;
  }
  return role.role?.replaceAll("_", " ") ?? "";
};

export const getRoleLabelWithFacility = (role) => {
  const label = getRoleLabel(role);
  return role?.facility ? `${label} - ${role.facility}` : label;
};
